import React from 'react';
import { Route, Routes } from "react-router-dom";

import { Layout } from "./components/Layout";
import { NoMatch } from "./components/NoMatch";
import { StaticPage } from "./components/StaticPage";

import './App.css';

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout/>}>
          <Route path=":language/:page" element={<StaticPage/>}/>

          {/* Using path="*"" means "match anything", so this route
                acts like a catch-all for URLs that we don't have explicit
                routes for. */}
          <Route path="*" element={<NoMatch/>}/>
        </Route>
      </Routes>
    </>
  );
}

export default App;
